var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-participate-list"},[(!_vm.linkList.length)?_c('em',[_vm._v(_vm._s(_vm.$t('participate.none')))]):_vm._e(),_c('div',{staticClass:"c-participate-list__items"},_vm._l((_vm.linkList),function(link){return _c('router-link',{key:link.topicId,attrs:{"to":_vm.getThreadLink(link)}},[_vm._v(" "+_vm._s(link.title)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }